import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade modal-md",
  id: "ModalGrupo",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-scrollable modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"15px"}
}
const _hoisted_5 = { class: "modal-header p-5" }
const _hoisted_6 = { class: "d-flex gap-4 p-0 align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  style: {"background":"rgb(236, 236, 236)"},
  class: "p-3 rounded"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"height":"fit-content","width":"fit-content","font-size":"18px","color":"#203972 !important"},
    class: "m-0 fas fa-pencil-alt"
  })
], -1)
const _hoisted_8 = { class: "m-0 subtitulo cor_texto_1" }
const _hoisted_9 = { class: "m-0 legenda text-muted" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  height: "2em",
  fill: "#afb7bd",
  widxmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "modal-body background_2",
  style: {"height":"400px"},
  id: "modalBody"
}
const _hoisted_13 = { class: "d-flex flex-column gap-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Informações", -1)
const _hoisted_15 = {
  style: {"border-radius":"10px"},
  class: "d-flex flex-column overflow-hidden p-5 w-100 background_1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "mb-2 cor_texto_1 text-nowrap text-truncate overflow-hidden text-nowrap text-truncate overflow-hidden" }, [
  /*#__PURE__*/_createTextVNode("Nome do grupo: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":".8rem"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "my-2 cor_texto_1 text-nowrap text-truncate overflow-hidden text-nowrap text-truncate overflow-hidden" }, [
  /*#__PURE__*/_createTextVNode("Nome do responsável: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_19 = {
  key: 1,
  class: "text-danger",
  style: {"font-size":".8rem"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Configurações", -1)
const _hoisted_21 = {
  style: {"border-radius":"10px"},
  class: "d-flex flex-column overflow-hidden w-100 background_1"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_30 = {
  style: {"border-radius":"10px"},
  class: "d-flex flex-column overflow-hidden w-100 background_1"
}
const _hoisted_31 = {
  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 gap-2 py-5 cursor-pointer",
  style: {"white-space":"nowrap"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_33 = {
  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 gap-2 py-5 cursor-pointer",
  style: {"white-space":"nowrap"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_35 = {
  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 gap-2 py-5 cursor-pointer",
  style: {"white-space":"nowrap"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Parceiros", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("section", {
  style: {"border-radius":"10px"},
  class: "d-flex flex-column overflow-hidden w-100 background_1"
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "m-0 texto bold text-muted",
    style: {"padding":"2rem","text-align":"center"}
  }, "Em breve . . .")
], -1)
const _hoisted_38 = { class: "modal-footer d-flex flex-nowrap justify-content-end align-items-center p-5 gap-4" }
const _hoisted_39 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 448 512"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("path", { d: "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" }, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1)
const _hoisted_50 = [
  _hoisted_49
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ModalDialogo = _resolveComponent("ModalDialogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.grupo.codGrupo ? `${_ctx.grupo.nome}` : 'Novo grupo'), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.grupo.qtdLoja && _ctx.grupo.qtdLoja > 0 ? `utilizado em ${_ctx.grupo.qtdLoja} loja${_ctx.grupo.qtdLoja > 1 ? 's' : ''}` : 'utilizado em nenhuma loja'), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.loadSalva && !_ctx.loadExclui && _ctx.fechaModal())),
              "aria-label": "Close"
            }, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("section", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.grupo.nome) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.grupo.nome]
                ]),
                (_ctx.tentouSalvar && !_ctx.grupo.nome)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "campo obrigatório!"))
                  : _createCommentVNode("", true),
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.grupo.responsavel) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.grupo.responsavel]
                ]),
                (_ctx.tentouSalvar && !_ctx.grupo.responsavel)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "campo obrigatório!"))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_20,
              _createElementVNode("section", _hoisted_21, [
                _createElementVNode("p", {
                  onClick: _cache[4] || (_cache[4] = () => _ctx.grupo.buscaPlaca = _ctx.grupo.buscaPlaca == 'S' ? 'N' : 'S'),
                  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 py-5 cursor-pointer"
                }, [
                  _createTextVNode("Busca placa "),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.grupo.buscaPlaca,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.grupo.buscaPlaca) = $event)),
                    "active-value": "S",
                    "inactive-value": "N",
                    size: "large",
                    class: "custom-switch",
                    style: {"pointer-events":"none"}
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_22,
                _createElementVNode("p", {
                  onClick: _cache[6] || (_cache[6] = () => _ctx.grupo.usaChecklist = _ctx.grupo.usaChecklist == 'S' ? 'N' : 'S'),
                  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 py-5 cursor-pointer"
                }, [
                  _createTextVNode("Utiliza checklist"),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.grupo.usaChecklist,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.grupo.usaChecklist) = $event)),
                    "active-value": "S",
                    "inactive-value": "N",
                    size: "large",
                    class: "custom-switch",
                    style: {"pointer-events":"none"}
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_23,
                _createElementVNode("p", {
                  onClick: _cache[8] || (_cache[8] = () => _ctx.grupo.oleoFracionado = _ctx.grupo.oleoFracionado == 'S' ? 'N' : 'S'),
                  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 py-5 cursor-pointer"
                }, [
                  _createTextVNode("Venda de óleo fracionado "),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.grupo.oleoFracionado,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.grupo.oleoFracionado) = $event)),
                    "active-value": "S",
                    "inactive-value": "N",
                    size: "large",
                    class: "custom-switch",
                    style: {"pointer-events":"none"}
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_24,
                _createElementVNode("p", {
                  onClick: _cache[10] || (_cache[10] = () => _ctx.grupo.alterarValor = _ctx.grupo.alterarValor == 'S' ? 'N' : 'S'),
                  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 py-5 cursor-pointer"
                }, [
                  _createTextVNode("Pode alterar valor"),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.grupo.alterarValor,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.grupo.alterarValor) = $event)),
                    "active-value": "S",
                    "inactive-value": "N",
                    size: "large",
                    class: "custom-switch",
                    style: {"pointer-events":"none"}
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_25,
                _createElementVNode("p", {
                  onClick: _cache[12] || (_cache[12] = () => _ctx.grupo.podeDesconto = _ctx.grupo.podeDesconto == 'S' ? 'N' : 'S'),
                  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 py-5 cursor-pointer"
                }, [
                  _createTextVNode("Pode dar desconto"),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.grupo.podeDesconto,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.grupo.podeDesconto) = $event)),
                    "active-value": "S",
                    "inactive-value": "N",
                    size: "large",
                    class: "custom-switch",
                    style: {"pointer-events":"none"}
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_26,
                _createElementVNode("p", {
                  onClick: _cache[14] || (_cache[14] = () => _ctx.grupo.formularioDeRecepcao = _ctx.grupo.formularioDeRecepcao == 'S' ? 'N' : 'S'),
                  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 py-5 cursor-pointer"
                }, [
                  _createTextVNode("Formulário de recepção"),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.grupo.formularioDeRecepcao,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.grupo.formularioDeRecepcao) = $event)),
                    "active-value": "S",
                    "inactive-value": "N",
                    size: "large",
                    class: "custom-switch",
                    style: {"pointer-events":"none"}
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_27,
                _createElementVNode("p", {
                  onClick: _cache[16] || (_cache[16] = () => _ctx.grupo.assinaturaDoCliente = _ctx.grupo.assinaturaDoCliente == 'S' ? 'N' : 'S'),
                  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 py-5 cursor-pointer"
                }, [
                  _createTextVNode("Assinatura do cliente"),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.grupo.assinaturaDoCliente,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.grupo.assinaturaDoCliente) = $event)),
                    "active-value": "S",
                    "inactive-value": "N",
                    size: "large",
                    class: "custom-switch",
                    style: {"pointer-events":"none"}
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_28,
                _createElementVNode("p", {
                  onClick: _cache[18] || (_cache[18] = () => _ctx.grupo.utilizaMO = _ctx.grupo.utilizaMO == 'S' ? 'N' : 'S'),
                  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 py-5 cursor-pointer"
                }, [
                  _createTextVNode("Utiliza valor de mão de obra"),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.grupo.utilizaMO,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.grupo.utilizaMO) = $event)),
                    "active-value": "S",
                    "inactive-value": "N",
                    size: "large",
                    class: "custom-switch",
                    style: {"pointer-events":"none"}
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_29,
                _createElementVNode("p", {
                  onClick: _cache[20] || (_cache[20] = () => _ctx.grupo.vendaEstoqueNegativo = _ctx.grupo.vendaEstoqueNegativo == 'S' ? 'N' : 'S'),
                  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 py-5 cursor-pointer"
                }, [
                  _createTextVNode("Venda de estoque negativo"),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.grupo.vendaEstoqueNegativo,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.grupo.vendaEstoqueNegativo) = $event)),
                    "active-value": "S",
                    "inactive-value": "N",
                    size: "large",
                    class: "custom-switch",
                    style: {"pointer-events":"none"}
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("section", _hoisted_30, [
                _createElementVNode("p", _hoisted_31, [
                  _createTextVNode(" Tipo Oferta "),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.grupo.tipoOferta,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.grupo.tipoOferta) = $event)),
                    placeholder: "Selecione um cargo..."
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayTipoOferta, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.nome,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _hoisted_32,
                _createElementVNode("p", _hoisted_33, [
                  _createTextVNode(" Layout App "),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.grupo.tipoApp,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.grupo.tipoApp) = $event)),
                    placeholder: "Selecione um cargo..."
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayLayoutApp, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codBandeira,
                          label: item.descricao,
                          value: item.codBandeira
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _hoisted_34,
                _createElementVNode("p", _hoisted_35, [
                  _createTextVNode(" Checklist Adicional "),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.grupo.checklistAdicional,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.grupo.checklistAdicional) = $event)),
                    placeholder: "Selecione um cargo..."
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayChecklistAdicional, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.checklist,
                          label: item.nome,
                          value: item.checklist
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _hoisted_36,
              _hoisted_37
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.modalDialogo.show())),
              style: {"height":"fit-content","white-space":"nowrap"},
              class: "btn btn-danger d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center m-0 texto"
            }, [
              (_ctx.loadExclui)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
                : (_openBlock(), _createElementBlock("svg", _hoisted_42, _hoisted_44)),
              _createTextVNode(" Excluir ")
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[25] || (_cache[25] = ($event: any) => (!_ctx.loadSalva && _ctx.salvaGrupo())),
              style: {"height":"fit-content","white-space":"nowrap"},
              class: "btn btn-danger d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center m-0 texto"
            }, [
              (_ctx.loadSalva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                : (_openBlock(), _createElementBlock("svg", _hoisted_48, _hoisted_50)),
              _createTextVNode(" Salvar ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ModalDialogo, {
      titulo: "Confirme sua ação",
      mensagem: "Tem certeza de que deseja remover este grupo?"
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.modalDialogo.hide())),
          style: {"height":"fit-content","white-space":"nowrap","font-size":"0.8rem !important"},
          class: "btn btn-secondary d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center m-0"
        }, " Cancelar "),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[27] || (_cache[27] = ($event: any) => {_ctx.modalDialogo.hide(); _ctx.deletaGrupo()}),
          style: {"height":"fit-content","white-space":"nowrap","font-size":"0.8rem !important"},
          class: "btn btn-danger d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center m-0"
        }, " Confirmar ")
      ]),
      _: 1
    })
  ]))
}